var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.367188 7.11719C-0.121094 7.60547 -0.121094 8.39844 0.367188 8.88672L6.61719 15.1367C7.10547 15.625 7.89844 15.625 8.38672 15.1367C8.875 14.6484 8.875 13.8555 8.38672 13.3672L4.26562 9.25H16.25C16.9414 9.25 17.5 8.69141 17.5 8C17.5 7.30859 16.9414 6.75 16.25 6.75H4.26953L8.38281 2.63281C8.87109 2.14453 8.87109 1.35156 8.38281 0.863281C7.89453 0.375 7.10156 0.375 6.61328 0.863281L0.363281 7.11328L0.367188 7.11719Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/back_arrow_icon.9e02b0e611cadf6ac641dea6036072be.svg";
export { ForwardRef as ReactComponent };